import { ChangeDetectorRef, Input } from '@angular/core';
import { EventEmitter, Output, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomatActivation } from 'src/app/model/devicePilomatActivation';
import { LogEvent } from 'src/app/model/logEvent';
import { MonthlyActivatedDevices } from 'src/app/model/monthlyActivatedDevices';
import { DeviceService } from 'src/app/service/device.service';
import { DateHelper } from 'src/app/util/dateHelper';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-devices-activated',
  templateUrl: './devices-activated.component.html',
  styleUrls: ['./devices-activated.component.css']
})
export class DevicesActivatedComponent implements OnInit {

  @ViewChild('devicesactivatedlisttable', { static: true }) listTable;
  @ViewChild('devicesactivatedtotalstable', { static: true }) totalsTable;
  @ViewChild('devicesactivatedlistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<DevicePilomatActivation>();
  @Input() filter: string;

  selectedDevice: any;
  selectedRow: number;

  monthlyActivations: MonthlyActivatedDevices[] = [];

  devicesList: DevicePilomatActivation[];
  activeDevC: number;
  piloActiveDevC: number;
  dataSource: MatTableDataSource<DevicePilomatActivation>;

  displayedColumnsTotals: string[] = ['month', 'year', 'activatedDevices', 'subTotalActivatedDevices'];
  displayedColumnsList: string[] = ['serial', 'activationDateFriendly'];

  constructor(private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.loader.showLoading();
    });

    this.getDeviceList();
  }

  ngOnChanges(changes: SimpleChanges) {

    this.listTable.dataSource.filter = this.filter.trim().toLowerCase();

  }

  getDeviceList() {
    this.loader.showLoading();

    const obs = this.deviceService.getActivatedDevices();
    obs.subscribe(data => {
      let activatedDevices = data;

      this.activeDevC = data.length;
      this.piloActiveDevC = data.length - 2;

      activatedDevices.sort(function (a, b) {
        return new Date(a.activationDate).getTime() - new Date(b.activationDate).getTime();
      });

      this.devicesList = activatedDevices;

      let startTime = new Date(activatedDevices[0].activationDate);
      let endTime = new Date();
      let monthsDifference = ((endTime.getFullYear() - startTime.getFullYear()) * 12) + (endTime.getMonth() - startTime.getMonth());

      let index = 0;
      let activationsSubTotal = 0;
      let currentMonth;
      let currentYear;
      for (let i = 0; i < monthsDifference; i++) {
        let currentMonthActivations = new MonthlyActivatedDevices();
        let monthlyActivatedDevices = 0;
        let currentDate = new Date(startTime);
        currentDate.setMonth(startTime.getMonth() + i);
        currentMonth = currentDate.getMonth();
        currentYear = currentDate.getFullYear();

        currentMonthActivations.month = DateHelper.getDateMonth(currentDate);
        currentMonthActivations.year = currentDate.getFullYear();

        let nextDevice = true;
        while (nextDevice && index < activatedDevices.length) {
          let deviceActivationDate = new Date(activatedDevices[index].activationDate);
          if (deviceActivationDate.getMonth() == currentMonth && deviceActivationDate.getFullYear() == currentYear) {
            monthlyActivatedDevices++;
            index++;
          } else {
            nextDevice = false;
          }
        }

        activationsSubTotal = activationsSubTotal + monthlyActivatedDevices;
        currentMonthActivations.activatedDevices = monthlyActivatedDevices;
        currentMonthActivations.subTotalActivatedDevices = activationsSubTotal;
        this.monthlyActivations.push(currentMonthActivations);
      }
      this.totalsTable.dataSource = new MatTableDataSource(this.monthlyActivations);
      this.totalsTable.dataSource.sort = this.sort;
      this.totalsTable.dataSource.filterPredicate = this.filterTable;

      this.listTable.dataSource = new MatTableDataSource(this.devicesList);
      this.listTable.dataSource.sort = this.sort;
      this.listTable.dataSource.filterPredicate = this.filterTable;

      this.loader.hideLoading();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }



  filterTable(data: DevicePilomatActivation, filter: string): boolean {
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    return false;
  }


  onRowClicked(row) {
    Log.debug('clicked device with id ' + row.id);

    this.selectedRow = row.id;

    this.selected.emit(row);
    this.selectedDevice = row;

    this.cdRef.detectChanges();
  }
}
